import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';

import { Text, Separator, Button } from '@cuemath/comps';

import { getAll as getStudentRegions } from 'actions/student-regions';
import { patch as updateStudentRegion } from 'actions/students';
import { closeModal } from 'actions/modal';

import { EVENT_TYPE } from 'constants/logger';
import { trackEvent } from 'modules/analytics';
import {
  Head,
  Footer,
  Message,
  FormWrapper,
  FieldWrapper,
  ButtonWrapper,
  renderFormField,
} from 'modules/form';

import { getInputChangeMethod, studentRegionsFormFields } from 'constants/form';

class EditStudentRegion extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      getStudentRegions: PropTypes.func.isRequired,
      updateStudentRegion: PropTypes.func.isRequired,
      invalidateStudent: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
    }).isRequired,
    data: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      form: {},
      formFields: studentRegionsFormFields,
      studentRegionPatch: store.patch(),
      patchInitiated: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      actions,
      studentRegions,
      students,
      data: { onUpdate },
    } = props;

    const { formFields, studentRegionPatch, patchInitiated } = state;
    const newFormFields = [...formFields];
    const newState = {};

    const regionList = store.getAll(studentRegions);
    const { data: regionListData } = regionList || {};

    const patchStudentRegion = store.patch(students, studentRegionPatch.id);
    const { resolved: patchStudentRegionResolved } = patchStudentRegion || {};

    if (regionListData) {
      const regionChoices = regionListData.map(item => ({
        label: `${item.name}`,
        value: item.value,
      }));

      newFormFields.map(item => {
        const { name } = item;
        if (name === 'studentRegions') item.choices = regionChoices;
        return item;
      });
      newState.formFields = newFormFields;
    }

    if (patchStudentRegionResolved && patchInitiated) {
      const { isPatched, isPatchingFailed } = patchStudentRegionResolved;
      if (isPatched) {
        onUpdate();
        actions.closeModal();
      } else if (isPatchingFailed) {
        const errorObj = store.getError(patchStudentRegionResolved);
        newState.errorText = errorObj ? errorObj.message : 'Something went wrong';
      }

      newState.patchInitiated = false;
    }
    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getStudentRegions();
  }

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onSubmit = event => {
    event.preventDefault();
    const {
      studentRegionPatch: { id, current },
      form,
      formFields,
    } = this.state;

    const {
      actions,
      data: { studentId },
    } = this.props;

    const data = {};

    trackEvent(EVENT_TYPE.ASSIGN_REGION_SUBMIT_CLICKED, { student_id: studentId });

    if (current && current.isPatching) return;

    formFields.forEach(({ name, param }) => {
      if (param && form[name]) data[param] = form[name];
    });
    this.setState({ patchInitiated: true }, () => {
      if (Object.keys(data).length) actions.updateStudentRegion(id, studentId, data);
    });
  };

  renderFormHeader = () => (
    <Head>
      <Text size="xlarge" align="center">
        Assign a Region
      </Text>
    </Head>
  );

  renderFormFields = () => {
    const { formFields, form } = this.state;

    return (
      <FieldWrapper>
        {formFields.map(field => {
          return renderFormField({
            ...field,
            value: form[field.name],
            onChange: this[getInputChangeMethod(field)],
          });
        })}
      </FieldWrapper>
    );
  };

  renderFormFooter = () => (
    <Footer>
      <ButtonWrapper>
        <Button label="Save" />
      </ButtonWrapper>
    </Footer>
  );

  render() {
    const { errorText } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <FormWrapper>
          {this.renderFormHeader()}
          <Separator transparent height="25" />
          {this.renderFormFields()}
          {errorText && <Message error={true}>{errorText}</Message>}
          <Separator transparent height="50" />
          {this.renderFormFooter()}
          <Separator transparent height="50" />
        </FormWrapper>
      </form>
    );
  }
}

export default connect(
  ({ studentRegions, students }) => ({ studentRegions, students }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getStudentRegions,
        updateStudentRegion,
        closeModal,
      },
      dispatch,
    ),
  }),
)(EditStudentRegion);
